import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "./utils";

// Tones: neutral (grey), info (blue), success (green), warning (amber), danger (red).
export const badgeVariants = cva(
  "tw-inline-flex tw-items-center tw-gap-1 tw-whitespace-nowrap tw-rounded-full tw-border tw-px-2 tw-py-0.5 tw-font-sans tw-text-xs tw-font-medium tw-leading-4",
  {
    variants: {
      tone: {
        neutral: "tw-border-border tw-bg-muted tw-text-muted-foreground",
        info: "tw-border-blue-200 tw-bg-blue-50 tw-text-blue-800",
        success: "tw-border-emerald-200 tw-bg-emerald-50 tw-text-emerald-800",
        warning: "tw-border-amber-200 tw-bg-amber-50 tw-text-amber-800",
        danger: "tw-border-red-200 tw-bg-red-50 tw-text-red-700",
        outline: "tw-border-border tw-bg-background tw-text-foreground",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

export const Badge = ({ className, tone = "neutral", ...props }) => (
  <span data-tone={tone} className={cn(badgeVariants({ tone }), className)} {...props} />
);

// The tone names the logic modules use ("ok", "warn", "bad", "info", "") as badge tones.
export const TONE_FROM_LOGIC = { ok: "success", warn: "warning", bad: "danger", info: "info", "": "neutral" };
export const toneOf = (logicTone) => TONE_FROM_LOGIC[logicTone || ""] || "neutral";
